import { render, staticRenderFns } from "./rewardRunForItEdit.vue?vue&type=template&id=54a9c68f&scoped=true&"
import script from "./rewardRunForItEdit.vue?vue&type=script&lang=js&"
export * from "./rewardRunForItEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54a9c68f",
  null
  
)

export default component.exports